import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78444e23"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cargo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label is-required" }, [
  /*#__PURE__*/_createElementVNode("text", null, "线路"),
  /*#__PURE__*/_createElementVNode("text", { class: "title-en" }, " Cargo Types ")
], -1))
const _hoisted_3 = { class: "form-item-checkbox" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["value", "id", "checked"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "radio weui-icon-checked" }, null, -1))
const _hoisted_7 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expressList, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          onClick: ($event: any) => (_ctx.setExpressId(item)),
          class: "g-radio checkbox weui-cells_checkbox"
        }, [
          _createElementVNode("input", {
            type: "checkbox",
            class: "g-checkbox checkbox weui-check",
            value: item.id,
            id: item.id,
            checked: _ctx.form.expressId === item.id
          }, null, 8, _hoisted_5),
          _hoisted_6,
          _createElementVNode("label", _hoisted_7, _toDisplayString(item.title) + "(" + _toDisplayString(item.note1) + ") ", 1)
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}